import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LogoMark } from "../../components/common/BrandVisuals";
import { useAdminAuth } from "../../context/AdminAuthProvider";
import { extractApiError } from "../../lib/adminApi";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
    const { status, login } = useAdminAuth();
    const location = useLocation();
    const nav = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [state, setState] = useState({ status: "idle", error: "" });

    if (status === "authenticated") {
        return <Navigate to="/admin" replace />;
    }
    if (status === "must_change_password") {
        return <Navigate to="/admin/change-password" replace />;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setState({ status: "submitting", error: "" });
        try {
            const data = await login(form.email.trim(), form.password);
            const target = location.state?.from || "/admin";
            nav(data.must_change_password ? "/admin/change-password" : target, {
                replace: true,
            });
        } catch (err) {
            setState({
                status: "error",
                error: extractApiError(err, "Identifiants incorrects."),
            });
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-ink flex items-center justify-center px-5"
        >
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8">
                    <LogoMark size="md" />
                </div>
                <div className="card-line p-8">
                    <div className="eyebrow mb-2">Espace administration</div>
                    <h1 className="font-serif text-2xl text-neutral-50 mb-6">
                        Connexion au cabinet
                    </h1>
                    <form onSubmit={onSubmit} className="space-y-5" noValidate>
                        <label className="block">
                            <span className="eyebrow block mb-2">
                                Adresse courriel
                            </span>
                            <input
                                type="email"
                                required
                                autoFocus
                                className="field-box"
                                value={form.email}
                                onChange={(e) =>
                                    setForm({ ...form, email: e.target.value })
                                }
                                data-testid="admin-login-email"
                            />
                        </label>
                        <label className="block">
                            <span className="eyebrow block mb-2">
                                Mot de passe
                            </span>
                            <input
                                type="password"
                                required
                                className="field-box"
                                value={form.password}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        password: e.target.value,
                                    })
                                }
                                data-testid="admin-login-password"
                            />
                        </label>
                        {state.status === "error" && (
                            <div
                                className="text-sm text-red-300 border border-red-900 bg-red-950/40 px-3 py-2"
                                data-testid="admin-login-error"
                            >
                                {state.error}
                            </div>
                        )}
                        <button
                            type="submit"
                            disabled={state.status === "submitting"}
                            className="btn-gold w-full justify-center"
                            data-testid="admin-login-submit"
                        >
                            <LogIn size={16} />
                            {state.status === "submitting"
                                ? "Connexion…"
                                : "Se connecter"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
